import { render, staticRenderFns } from "./baseConsumableCus.vue?vue&type=template&id=37b5c410&"
import script from "./baseConsumableCus.vue?vue&type=script&lang=js&"
export * from "./baseConsumableCus.vue?vue&type=script&lang=js&"
import style0 from "./baseConsumableCus.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports